<template>
    <v-container fluid class="pa-0">

        <swiper ref="mySwiper" :options="swiperOptions">

            <swiper-slide>
                    <v-img :aspect-ratio="10/17.773" :width="width" :src="p1"></v-img>
            </swiper-slide>

            <swiper-slide>
                    <v-img :aspect-ratio="10/17.773" :width="width" :src="p2"></v-img>
            </swiper-slide>

            <swiper-slide>
                    <v-img :aspect-ratio="10/17.773" :width="width" :src="p3"></v-img>
            </swiper-slide>

            <div class="swiper-pagination" slot="pagination"></div>
        </swiper>

    </v-container>
</template>


<script>
    import {
        Swiper,
        SwiperSlide,
        directive
    } from 'vue-awesome-swiper'


    export default {
        components: {
            Swiper,
            SwiperSlide
        },
        directives: {
            swiper: directive
        },
        name: 'swiper-example-multiple-slides-per-view',
        title: 'Multiple slides per view',

        data() {
            return {
                swiperOptions: {
                    loop: false, //無限ループ
                    spaceBetween: 20, //余白
                    centeredSlides: false, //センター表示
                    clickable: true, //クリック
                    pagination: { //ページネーション
                        el: '.swiper-pagination'
                    },
                    slidesPerView: 1.8,
                    // Some Swiper option/callback...
                },
      // コンテンツ情報

        p1: './Images/tickets_pic/tickets_maki_p1_750w.jpg',
        p2: './Images/tickets_pic/tickets_maki_p2_750w.jpg',
        p3: './Images/tickets_pic/tickets_maki_p3_750w.jpg',
            }
        },


        computed: {
            swiper() {
                return this.$refs.mySwiper.$swiper
            }
        },

    }
</script>

<style lang="scss" scoped>
    .swiper-container {
        width: 100%;
        //        height: 700px !important;
        padding-bottom: 50px;
    }

    .swiper-slide {
        background: inherit;
        color: #666;
        font-size: 24px;
        display: flex;
        height: auto;
        justify-content: center;
        align-items: flex-start;

        .v-card {
            height: 100%;
            background: rgb(186, 78, 213);
            background: linear-gradient(176deg, rgba(186, 78, 213, 1) 0%, rgba(165, 90, 230, 1) 46%, rgba(22, 162, 190, 1) 100%);
        }
    }


    .swiper-slide {

        .v-image {
            background-position: center;
            background-size: cover;
        }
    }
</style>